module.exports = __webpack_public_path__ + "static/media/logo_bidv.e67912ac.svg";